import { getWishlist, updateWishlist } from '../functions/wishlist';

export default function ProductsWishlist() {
    const wishlistKey = 'wishlist'; // localStorage key
    const productsList = document.querySelector('#productsList');
    const openWishlistBtn = document.getElementById('openWishlist');
    const wishlistModal = document.querySelector('.wishlist');
    const wishlistAlert = document.querySelector('.wishlist-alert');
    const wishlistInfo = document.querySelector('.wishlist-info');
    if (!productsList && !openWishlistBtn && !wishlistModal) return;

    openWishlistBtn.addEventListener('click', () => {
        wishlistModal.classList.add('active');
    });

    wishlistModal.addEventListener('click', element => {
        if (!element.target.classList.contains('wishlist__card')) {
            element.target.classList.remove('active');
        }
        if (element.target.classList.contains('wishlist-hide-card')) {
            wishlistModal.classList.remove('active');
        }
        if (element.target.classList.contains('wishlist-remove-product')) {
            const productId = element.target.dataset.id;
            removeFromWishlist(productId);
        }
    });

    function saveWishlist(wishlist) {
        localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
    }

    function addToWishlist(productId, quantity = 1) {
        let wishlist = getWishlist();
        const existingProductIndex = wishlist.findIndex(item =>
            typeof item === 'object'
                ? item.id === productId
                : item === productId
        );

        if (existingProductIndex === -1) {
            wishlist.push({ id: productId, quantity: parseInt(quantity) });
            saveWishlist(wishlist);
            updateWishlist();
            if (wishlistInfo) {
                wishlistInfo.classList.add('-show');
                setTimeout(() => {
                    wishlistInfo.classList.remove('-show');
                }, 3600);
            }
        } else {
            if (typeof wishlist[existingProductIndex] === 'object') {
                wishlist[existingProductIndex].quantity = parseInt(quantity);
                saveWishlist(wishlist);
                updateWishlist();
                if (wishlistInfo) {
                    wishlistInfo.classList.add('-show');
                    setTimeout(() => {
                        wishlistInfo.classList.remove('-show');
                    }, 3600);
                }
            } else {
                wishlist[existingProductIndex] = {
                    id: productId,
                    quantity: parseInt(quantity),
                };
                saveWishlist(wishlist);
                updateWishlist();
                if (wishlistInfo) {
                    wishlistInfo.classList.add('-show');
                    setTimeout(() => {
                        wishlistInfo.classList.remove('-show');
                    }, 3600);
                }
            }
        }
    }

    function removeFromWishlist(productId) {
        let wishlist = getWishlist();
        wishlist = wishlist.filter(item =>
            typeof item === 'object'
                ? item.id !== productId
                : item !== productId
        );
        saveWishlist(wishlist);
        updateWishlist();
    }

    if (productsList) {
        productsList.addEventListener('click', productBtn => {
            if (productBtn.target && productBtn.target.id === 'addToList') {
                let productId =
                    productBtn.target.getAttribute('data-product-id');
                let productBox = productBtn.target.closest('.product-box');
                let quantityInput = productBox.querySelector(
                    '.product-quantity__input'
                );
                let quantity = quantityInput ? quantityInput.value : 1;

                if (productId) {
                    addToWishlist(productId, quantity);
                }
            }
        });
    }

    document.addEventListener('click', function (e) {
        if (e.target.classList.contains('wishlist-quantity-change')) {
            const productId = e.target.dataset.productId;
            const direction = e.target.dataset.direction;
            const inputElement = e.target.parentElement.querySelector(
                '.wishlist-quantity-input'
            );
            let currentValue = parseInt(inputElement.value);

            if (direction === 'up') {
                currentValue += 1;
            } else if (direction === 'down' && currentValue > 1) {
                currentValue -= 1;
            }

            inputElement.value = currentValue;

            let wishlist = getWishlist();
            const existingProductIndex = wishlist.findIndex(item =>
                typeof item === 'object'
                    ? item.id === productId
                    : item === productId
            );

            if (existingProductIndex !== -1) {
                if (typeof wishlist[existingProductIndex] === 'object') {
                    wishlist[existingProductIndex].quantity = currentValue;
                } else {
                    wishlist[existingProductIndex] = {
                        id: productId,
                        quantity: currentValue,
                    };
                }
                saveWishlist(wishlist);
                updateWishlist();
            }
        }
    });

    updateWishlist();
}
